export const ctaData = {
  heading: "Stay up-to-date with what we’re doing",
  subHeading: "35,000+ already joined"
};


export const ctaFormData = {
    placeholder: "Enter your email address",
    errorMessage: "Whoops, make sure it's an email!",
    buttonText: "Contact Us"
}
